import React from "react";

const USPItems = ({ items }) => {
    return (
        <div className="uspItems-container">
            {items.slice(0, 4).map((i) => (
                <div className="uspItem" key={i.title}>
                    <a className="product-detail__information-tab--link" href="#variantviseuspitems">
                    <img src={i.uspImage} width="50" height="50" />
                    <span className="text--center display--block">{i.title}</span>
                    </a>
                </div>
            ))}
        </div>
    );
};

export default USPItems;
